Apt.fn.make('feed', {
	/**
	 * Initialize module
	 */
	init() {
		this.message = Apt.fn.message()
			.init({
				placeholder: 'Describe your inventory and listing sources',
				required: true
			});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.destroy(this, 'message');
	}
});